import React from "react";

console.log("🔥 HILO FILE UPDATED");

const PopUpHighLowResults = ({ resultsData, catMid, marketType }) => {

    const resultData = resultsData;
    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };
    /*
        HILO RESULT
        result = 1  -> High
        result = 2  -> Low
        result = 3  -> Snap
    */
    const markets = [
        {
            label: resultData?.cat_rnr1,
            resultValue: 1
        },
        {
            label: resultData?.cat_rnr2,
            resultValue: 2
        },
        {
            label: resultData?.cat_rnr3,
            resultValue: 3
        }
    ];


    return (
        <div>
            <div id="ResultsData">
                <div className="left-content site_family">
                    <div
                        id="hilo"
                        style={{
                            display: marketType == 13 ? "" : "none"
                        }}
                    >
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(resultData?.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div
                                        style={{
                                            width: "100%",
                                            textAlign: "center"
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                textAlign: "center",
                                                marginTop: "10px"
                                            }}
                                        >
                                            Community Cards
                                        </div>
                                        <div
                                            style={{
                                                width: "100%",
                                                border: "1px solid #c8dec8",
                                                borderRadius: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "10px",
                                                boxSizing: "border-box"
                                            }}
                                        >
                                            {resultData?.c1 && (

                                                <img
                                                    src={`/assets/images/cards/${resultData.c1}.svg`}
                                                    alt={resultData.c1}
                                                    draggable={false}
                                                    style={{
                                                        width: "55px",
                                                        height: "auto",
                                                        display: "block"
                                                    }}
                                                />
                                            )}
                                            {resultData?.c2 && (
                                                <img
                                                    src={`/assets/images/cards/${resultData.c2}.svg`}
                                                    alt={resultData.c2}
                                                    draggable={false}
                                                    style={{
                                                        width: "55px",
                                                        height: "auto",
                                                        display: "block"
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            marginTop: "25px"
                                        }}
                                    >
                                        {markets.map((market, index) => {
                                            const winner =
                                                Number(resultData?.result) ===
                                                market.resultValue;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        textAlign: "center",
                                                        marginBottom: "15px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            textAlign: "center",
                                                            fontSize: "22px",
                                                            fontWeight: "bold",
                                                            color: "#292d32",
                                                            marginBottom: "3px"
                                                        }}
                                                    >
                                                        {market.label}
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            textAlign: "center",
                                                            fontSize: "16px",
                                                            fontWeight: "700",
                                                        }}
                                                    >
                                                        {winner
                                                            ? "WINNER"
                                                            : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`

                    #hilo .card-body {
                        width: 100%;
                    }

                    #hilo .card-body img {
                        max-width: none !important;
                    }

                    #hilo .hilo-results {
                        width: 100%;
                    }

                `}
            </style>
        </div>
    );
};
export default PopUpHighLowResults;